import { Deserializable } from '../../protocols/deserializable';
import { EmployerPlanDesignatedUnit } from './employer-plan-designated-unit';
import { RemittanceFrequencyType } from '../../shared/remittance-frequency-type';
import { EmployerPlanType } from './employer-plan-type';
import { EmployerPlanComment } from './employer-plan-comment';

export class EmployerPlan implements Deserializable {
  public id!: number;
  public employerPlanTypeId!: number;
  public employerPlanType!: EmployerPlanType;
  public employerId!: number;
  public employerName!: string;
  public remittanceFrequencyTypeId!: number;
  public remittanceFrequencyType!: RemittanceFrequencyType;
  public planEstablishmentDate!: string;
  public designatedUnits!: EmployerPlanDesignatedUnit[];
  public comments?: EmployerPlanComment[];

  onDeserialize(): void {
    if (!!this.designatedUnits) {
      this.designatedUnits = window?.injector?.Deserialize.arrayOf(EmployerPlanDesignatedUnit, this.designatedUnits);
    }
    if (!!this.comments) {
      this.comments = window?.injector?.Deserialize.arrayOf(EmployerPlanComment, this.comments ?? []);
    }
    if (!!this.employerPlanType) {
      this.employerPlanType = window?.injector?.Deserialize.instanceOf(EmployerPlanType, this.employerPlanType);
    }
    if (!!this.remittanceFrequencyType) {
      this.remittanceFrequencyType = window?.injector?.Deserialize.instanceOf(
        RemittanceFrequencyType,
        this.remittanceFrequencyType
      );
    }
  }
}
